<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56.693" height="56.692" viewBox="0 0 56.693 56.692">
    <path id="Path_2" data-name="Path 2" d="M28.346,0A28.346,28.346,0,1,0,56.693,28.346,28.378,28.378,0,0,0,28.346,0m23,28.346A22.88,22.88,0,0,1,46.379,42.6L14.094,10.314A22.981,22.981,0,0,1,51.347,28.346m-46,0a22.886,22.886,0,0,1,4.968-14.253L42.6,46.379A22.982,22.982,0,0,1,5.346,28.346" fill="currentColor"/>
  </svg>
</template>
